import { AdvertisementType } from "@/common/types"
import EmptyMobileAdvertisement from "@/components/advertisements/EmptyMobileAdvertisement"
import Advertisement from "@/components/advertisements/MobileAdvertisement"
import useListAdvertisementImages from "@/hooks/api/advertisements/ustListAdvertisementImages"
import useIsMobile from "@/hooks/useIsMobile"
import { Box, Stack, Typography } from "@mui/material"

export const Footer = () => {
  const isMobile = useIsMobile()
  const { data: advertisementImages, isLoading: advertisementsLoading } =
    useListAdvertisementImages()

  if (advertisementsLoading) {
    return <>loading..</>
  }
  const mobileImage: AdvertisementType =
    advertisementImages.data.filter((image: AdvertisementType) =>
      image.slot_name.includes("mobile")
    )[0] || undefined

  return (
    <Box
      sx={{
        position: isMobile ? "fixed" : "static",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "white",
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        textAlign: "center",
        paddingY: isMobile ? "0px" : "10px",
        zIndex: 9997,
      }}
    >
      <Stack>
        {isMobile && (
          <>
            {mobileImage ? (
              <Advertisement
                hrefLink={mobileImage.action_link}
                imageUrl={mobileImage.mobile_image}
                aspectRatio="short"
                additionalStyling={{
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "8px",
                  maxWidth: "100%",
                  maxHeight: "48px",
                }}
                companyName={mobileImage.company_name}
                advertisementId={mobileImage.advertisement_id}
              />
            ) : (
              <EmptyMobileAdvertisement
                additionalStyling={{
                  borderTopRightRadius: "8px",
                  borderTopLeftRadius: "8px",
                  maxWidth: "100%",
                  maxHeight: "48px",
                }}
              />
            )}

            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "30px", // Adjust height for gradient effect
                // background:
                //   "linear-gradient(to bottom, rgba(255,255,255,0), white)",
                pointerEvents: "none", // Ensures interactions go through
              }}
            />
          </>
        )}
        {isMobile ? (
          <></>
        ) : (
          <Typography
            variant={isMobile ? "caption" : "subtitle2"}
            color="black"
          >
            Made for locals by locals
          </Typography>
        )}
      </Stack>
    </Box>
  )
}
